var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"data-cy":"not-found"}},[(!_vm.isSettings)?_c('div',[_c('NotFound')],1):_c('div',{staticClass:"not-found-background"},[_c('PageSettings',{attrs:{"useslot":true}},[_c('NotFound')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }